import { cn } from '@/lib/utils';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  accent?: 'emerald' | 'rose' | 'amber' | 'sky' | 'indigo' | 'violet' | 'slate' | 'fuchsia';
  padding?: 'sm' | 'md' | 'lg';
}

const accents = {
  emerald: 'border-r-4 border-emerald-500',
  rose: 'border-r-4 border-rose-500',
  amber: 'border-r-4 border-amber-500',
  sky: 'border-r-4 border-sky-500',
  indigo: 'border-r-4 border-indigo-500',
  violet: 'border-r-4 border-violet-500',
  slate: 'border-r-4 border-slate-500',
  fuchsia: 'border-r-4 border-fuchsia-500',
};

const paddings = {
  sm: 'p-4',
  md: 'p-5',
  lg: 'p-6',
};

export function Card({ children, className, accent, padding = 'md' }: CardProps) {
  return (
    <div
      className={cn(
        'glass rounded-2xl shadow-soft',
        paddings[padding],
        accent && accents[accent],
        className,
      )}
    >
      {children}
    </div>
  );
}
